import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { GraduationCap, UserCircle2, LogOut, Trophy } from 'lucide-react';
import { useAuth } from '../lib/auth';

const Navbar = () => {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      await signOut();
      navigate('/');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <nav className="bg-white shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex">
            <Link to="/" className="flex items-center">
              <GraduationCap className="h-8 w-8 text-secondary-600" />
              <span className="ml-2 text-2xl font-bold text-secondary-600 hidden sm:inline">NoStress Exams</span>
              <span className="ml-2 text-2xl font-bold text-secondary-600 sm:hidden">NoStress</span>
            </Link>
          </div>
          <div className="flex items-center space-x-1 sm:space-x-4">
            {user ? (
              <>
                <Link
                  to="/mes-fiches"
                  className="text-gray-600 hover:text-gray-900 px-2 sm:px-3 py-2 rounded-md text-sm font-medium"
                >
                  <span className="hidden sm:inline">Mes fiches</span>
                  <span className="sm:hidden">Fiches</span>
                </Link>
                <Link
                  to="/grand-quiz"
                  className="flex items-center text-gray-600 hover:text-gray-900 px-2 sm:px-3 py-2 rounded-md text-sm font-medium"
                >
                  <Trophy className="h-5 w-5 sm:mr-2" />
                  <span className="hidden sm:inline">Le grand Quiz</span>
                  <span className="sm:hidden">Quiz</span>
                  <span className="ml-1 px-1.5 py-0.5 text-xs font-medium bg-purple-100 text-purple-800 rounded-full">
                    <span className="hidden sm:inline">Nouveau</span>
                    <span className="sm:hidden">!</span>
                  </span>
                </Link>
                <Link
                  to="/account"
                  className="flex items-center text-gray-600 hover:text-gray-900 px-2 sm:px-3 py-2 rounded-md text-sm font-medium"
                >
                  <UserCircle2 className="h-5 w-5 sm:mr-2" />
                  <span className="hidden sm:inline">Mon compte</span>
                </Link>
                <button
                  onClick={handleSignOut}
                  className="flex items-center text-gray-600 hover:text-gray-900 px-2 sm:px-3 py-2 rounded-md text-sm font-medium"
                >
                  <LogOut className="h-5 w-5 sm:mr-2" />
                  <span className="hidden sm:inline">Déconnexion</span>
                </button>
              </>
            ) : (
              <>
                <Link
                  to="/login"
                  className="text-gray-600 hover:text-gray-900 px-2 sm:px-3 py-2 rounded-md text-sm font-medium"
                >
                  Se connecter
                </Link>
                <Link
                  to="/register"
                  className="bg-secondary-600 text-white hover:bg-secondary-700 px-4 py-2 rounded-md text-sm font-medium"
                >
                  <span className="hidden sm:inline">Créer un compte</span>
                  <span className="sm:hidden">Créer</span>
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;